module.exports = __webpack_public_path__ + "static/media/checkin_out_add.bfe1b544.svg";